import { useReducer } from 'react';

import { DataPayload } from 'types/reduxTypes/ActionTypes';
import { EditTechnicalLicenseMemberType } from 'types/people/editMemberProfile';
import { SetTechnicalLicenseFieldType } from 'types/reduxTypes/ActionTypes/PeopleTypes';
import { reducer, initialState } from './reducer';
import {
  setField as setFieldAC,
  setAll as setAllAC,
  setEmiratesId as setEmiratesIdAC,
  setVisa as setVisaAC,
  setShowError as setShowErrorAC,
  setPassport as setPassportAC,
} from './actions';

const useEditTLHMemberHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setField = (payload: SetTechnicalLicenseFieldType) => {
    dispatch(setFieldAC(payload));
  }

  const setShowError = (payload: SetTechnicalLicenseFieldType) => {
    dispatch(setShowErrorAC(payload));
  }

  const setAll = (payload: DataPayload<EditTechnicalLicenseMemberType>) => {
    dispatch(setAllAC(payload));
  }

  const setEmiratesId = (payload: DataPayload<string | Blob>) => {
    dispatch(setEmiratesIdAC(payload));
  }

  const setVisa = (payload: DataPayload<string | Blob>) => {
    dispatch(setVisaAC(payload));
  }

  const setPassport = (payload: DataPayload<string | Blob>) => {
    dispatch(setPassportAC(payload));
  }

  return {
    state,
    setAll,
    setField,
    setEmiratesId,
    setVisa,
    setPassport,
    setShowError,
  }
}

export default useEditTLHMemberHook;
